import { withSecondaryTypeface } from 'style-utils/text';
import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';
import { TableCell } from '../../BonusAmountAvailable/style/BonusAmountAvailable.style';

export const TitleBonusSpecs = styled.h3`
  height: 24px;
  width: 80px;
  margin: 0;
  font-family: var(--secondary-font-family), sans-serif;
  ${media.desktop`
    font-size: 18px;
    font-weight: 800;
    line-height: 18px;
    height: 18px;
  `}
`;

export const TotalRow = styled.div<{
  $hasSpendibility?: boolean;
  $isTableOpen?: boolean;
}>`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px
    ${({ $hasSpendibility, $isTableOpen }) =>
      $hasSpendibility && $isTableOpen
        ? '0'
        : $hasSpendibility
          ? '16px'
          : '20px'};
  width: 100%;
`;

export const BoldTotalAmount = styled(TableCell)`
  display: flex;
  font-family: var(--secondary-font-family), sans-serif;
  font-size: 18px;
  font-weight: 700;
  line-height: 100%;
  margin-left: auto;
  ${media.desktop`
    align-items: unset;
    justify-content: unset;
    line-height: unset;
    margin: 0;
    margin-left: auto;
    height: 18px;
    font-size: 16px;
    font-weight: 800;
  `}
`;

export const ShowSpendibility = styled.u<{ $isOpen?: boolean }>`
  height: 18px;
  width: 150px;
  margin: 0;
  padding: ${({ $isOpen }) => ($isOpen ? '16px 0' : '0')};
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  cursor: pointer;
  ${withSecondaryTypeface};
`;

export const TableRowSpecs = styled.div<{ $insetDivider?: string }>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 0;
  width: 100%;
  position: relative;

  &:not(:last-child)::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: ${({ $insetDivider }) => $insetDivider ?? '0'};
    right: ${({ $insetDivider }) => $insetDivider ?? '0'};
    height: 1px;
    background-color: lightgray;
  }
`;

export const TableSpecs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 8px 12px;
  background-color: #f2f2f2;
  margin: 0 auto;
  border-radius: 10px;
`;

export const SpecsTitle = styled(TableCell)<{ $isLast?: boolean }>`
  font-family: var(--secondary-font-family), sans-serif;
  font-weight: 700;
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  padding-bottom: ${({ $isLast }) => ($isLast ? '12px' : '5px')};
`;

export const SpecsParagraph = styled.h1<{
  $isLast?: boolean;
  $isRealBonusRoute?: boolean;
  $isFirst?: boolean;
}>`
  font-family: var(--primary-font-family), sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  margin: 0;
  padding-bottom: ${({ $isLast, $isRealBonusRoute }) =>
    $isLast && $isRealBonusRoute ? '6px' : '0'};
  padding-top: ${({ $isFirst, $isRealBonusRoute }) =>
    $isFirst && $isRealBonusRoute && '6px'};
`;

////////////////// DROPDOWN //////////////////////

export const ShowSpendibilityDropdown = styled.u`
  height: 18px;
  width: 150px;
  margin: 0;
  padding: 5px;
  font-size: 14px;
  font-weight: 700;
  line-height: 100%;
  cursor: pointer;
  ${withSecondaryTypeface};
`;

export const TableSpecsDropdown = styled.div`
  display: table;
  width: 100%;
  border-collapse: collapse;
  background-color: #f2f2f2;
  align-items: center;
  text-align: center;
  margin: 0 auto;
  border-radius: 8px;
`;
